// extracted by mini-css-extract-plugin
module.exports = {"ticket":"index-module--ticket--GGclQ","tickets":"index-module--tickets--2LdkS"};